import { Components, Theme } from "@mui/material";

export const MuiMenuItem: Components<Omit<Theme, "MuiMenuItem">>["MuiMenuItem"] = {
  styleOverrides: {
    root: {
      minWidth: 250,
      gap: "8px",
      borderRadius: "6px",
      padding: "12px 8px",
      fontFamily: "Inter",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16.8px",
      letterSpacing: "0%",
    },
  },
};
